module.exports = __webpack_public_path__ + "static/media/join_full_black_24dp.653fdb66.svg";